import React from 'react';
import {CHART_MUTED_TEXT} from './chartColors';

// Tooltip customizado do recharts: recebe a linha de dado completa (não só a
// série renderizada) para exibir campos extra (ex.: qty/items junto de patients).
export default function RowTooltip({active, payload, labelKey, fields}) {
    if (!active || !payload?.length) return null;
    const row = payload[0].payload;

    return (
        <div
            style={{
                background: '#fcfcfb',
                border: '1px solid #e0e0e0',
                borderRadius: 6,
                padding: '8px 12px',
                fontSize: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            }}
        >
            <div style={{fontWeight: 600, marginBottom: 4}}>{row[labelKey]}</div>
            {fields.map((field) => (
                <div key={field.key} style={{display: 'flex', justifyContent: 'space-between', gap: 16}}>
                    <span style={{color: CHART_MUTED_TEXT}}>{field.label}</span>
                    <span>{field.formatter ? field.formatter(row[field.key]) : row[field.key]}</span>
                </div>
            ))}
        </div>
    );
}
